import { render, staticRenderFns } from "./MovingFolderTree.vue?vue&type=template&id=9fcd9fa0"
import script from "./MovingFolderTree.vue?vue&type=script&lang=ts"
export * from "./MovingFolderTree.vue?vue&type=script&lang=ts"
import style0 from "./MovingFolderTree.vue?vue&type=style&index=0&id=9fcd9fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports